import { Script } from "blitz"
import React from "react"

export const InstagramEmbedScript = () => (
  <Script id="ig-embed" src="https://www.instagram.com/embed.js" />
)
